export default "__VITE_ASSET__CiQI3tEX__"